import { FC } from 'react';

import { Box, Flex, rem, SkeletonCircle, SkeletonText, StyleProps } from '@bonusly/design-system';

type MessageSkeletonProps = StyleProps;

export const MessageSkeleton: FC<MessageSkeletonProps> = (props) => {
	return (
		<Flex columnGap={4} {...props}>
			<Box>
				<SkeletonCircle boxSize={rem(48)} />
			</Box>

			<Box flexGrow={1}>
				<SkeletonText noOfLines={1} skeletonHeight={3} mb={rem(10)} w={rem(270)} />
				<SkeletonText noOfLines={3} skeletonHeight={3} spacing={3} my={1.5} />
			</Box>
		</Flex>
	);
};
